module.exports = require("import-in-the-middle");